import MarkdownIt from 'markdown-it'
import imgSizePlugin from 'markdown-it-imsize'
import taskLists from 'markdown-it-task-lists'

// import centerText from '@/third/markdown-it-center-text'

const mdParser = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
})

mdParser.use(imgSizePlugin)
// mdParser.use(centerText)
mdParser.use(taskLists, { enabled: true })

async function renderHTML(text: string) {
  return mdParser.render(text)
}
export { renderHTML }
export default mdParser
